<div class="detailed-analysis">
  @for (section of phaseSections; track section.phase) {
    @let mode = getDisplayMode(section.phase);
    <section class="analysis-section">
      <div class="analysis-section-header">
        <h3 class="analysis-section-title">
          {{ section.titleKey | transloco }}
        </h3>

        <div class="view-mode-toggle" role="group">
          <button
            type="button"
            class="view-mode-button"
            [class.view-mode-button--active]="mode === 'table'"
            (click)="setDisplayMode(section.phase, 'table')"
          >
            <i class="pi pi-table"></i>
            {{ 'project.steps.viewTable' | transloco }}
          </button>
          <button
            type="button"
            class="view-mode-button"
            [class.view-mode-button--active]="mode === 'heatmap'"
            (click)="setDisplayMode(section.phase, 'heatmap')"
          >
            <i class="pi pi-th-large"></i>
            {{ 'project.steps.viewHeatmap' | transloco }}
          </button>
        </div>
      </div>

      @if (projectId(); as currentProjectId) {
        <app-provider-results-table
          [projectId]="currentProjectId"
          [phase]="section.phase"
          [displayMode]="mode"
          [allowSubcriteriaAttributeModal]="false"
          [allowViewResultsModal]="false"
          [showCompletePhaseButton]="false"
          [showScoreCircle]="false"
          [showLegend]="false"
          [includedHrToolDirectusIds]="includedHrToolDirectusIds()"
        />
      }
    </section>
  }
</div>
